import { motion } from "framer-motion";
import { Lightbulb, Cpu } from "@phosphor-icons/react";
import { QualityRing } from "@/components/QualityRing";

export function MetricsPanel({ result }) {
  if (!result) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="stp-card grid grid-cols-1 gap-6 rounded-3xl p-6 sm:grid-cols-[auto_1fr] sm:p-8"
      data-testid="metrics-bento"
    >
      <div className="flex items-center gap-4 sm:flex-col sm:items-start">
        <QualityRing score={result.quality_score} />
        <div className="flex items-center gap-1.5 font-mono text-[11px] text-mist">
          <Cpu size={12} weight="bold" /> ~{result.est_tokens} tokens
        </div>
      </div>
      <div>
        <p className="text-xs font-medium uppercase tracking-wider text-mist">Why this works</p>
        {result.explanation && (
          <p className="mt-2 text-[15px] leading-relaxed text-ink" data-testid="insight-panel">{result.explanation}</p>
        )}
        <div className="mt-4 flex flex-wrap gap-2" data-testid="techniques-list">
          {result.techniques?.map((t, i) => (
            <span key={i} className="rounded-full bg-brand-soft px-3 py-1 text-xs font-medium text-brand">{t}</span>
          ))}
        </div>
        {result.tips?.length > 0 && (
          <ul className="mt-5 space-y-2 border-t border-black/5 pt-4">
            {result.tips.map((tip, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-mist">
                <Lightbulb size={16} weight="fill" className="mt-0.5 shrink-0 text-[#FF9F0A]" />
                <span>{tip}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </motion.div>
  );
}
